import { openOverlay, closeOverlay } from '../overlay/animate';

const openFilterBtn = document.querySelector('.js-recipe-filter-open-btn');
const closeFilterBtns = document.querySelectorAll('.js-recipe-filter-close-btn');
const filter = document.querySelector('.js-recipe-filter');

const init = () => {
    if (!openFilterBtn) return;

    // open recipe filter
    openFilterBtn.addEventListener('click', (event) => {
        event.preventDefault();
        openOverlay(filter);
    });

    // close recipe filter
    if (closeFilterBtns.length > 0) {
        closeFilterBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                event.preventDefault();
                closeOverlay(filter);
            });
        });
    }
};

export default init;
